export default {
  Model: {
    DISPLAY_NAME: 'displayName',
    FIRST_NAME: 'firstName',
    FULL_NAME: 'fullName',
    AVATAR: 'avatar',
    ID: 'id',
    SLUG: 'slug',
    EMAIL: 'email',
  },
  Actions: {
    FETCH_USER_BY_ID_SUCCESS: 'users/FETCH_USER_BY_ID_SUCCESS',
    UPDATE_USER_SUCCESS: 'users/UPDATE_USER_SUCCESS',
    UPDATE_USER_PHOTO_SUCCESS: 'users/UPDATE_USER_PHOTO_SUCCESS',
    UPDATE_USER_FLAG_SUCCESS: 'users/UPDATE_USER_FLAG_SUCCESS',
  },
  State: {
    USERS_BY_USER_ID: 'USERS_BY_USER_ID',
  },
};
